import lodash from 'lodash';
import { BaseModel } from './../../libraries';
class UserInfoModel extends BaseModel {
    // 单例模式 全局唯一
    constructor() {
        super();
        if (!lodash.isEmpty(UserInfoModel.UserInfoModel)) {
            return UserInfoModel.UserInfoModel;
        }
        this.onInit({
            type: 'object',
            storageLoading: false,
        });
        UserInfoModel.UserInfoModel = this;
    }
    //直播间ID
    get liveId() {
        return lodash.get(this.value, 'liveId');
    }
    get userInfo() {
        return lodash.get(this.value, 'userInfo', {});
    }
    get userAvatar() {
        return lodash.get(this.userInfo, 'userAvatar', 'https://static.mudu.tv/assets/img/icon-logo.png');
    }
    get userCode() {
        return lodash.get(this.userInfo, 'userCode');
    }
    get userName() {
        return lodash.get(this.userInfo, 'userName', '游客');
    }
}
export function createUserModel() {
    return new UserInfoModel();
}
